import * as types from './types';
import {getRoleById, getRoleList} from '@/services/api/roles';
import {getShipList} from '@/services/api/common';
import {getShipFromVOP} from '../services/api/common';
import Vue from 'vue';
//set current active tab so we can switch user to that active tab
export const setCurrentTab = ({commit}: any, tab: any) => {
  commit(types.SET_CURRENT_TAB, tab);
};
//hide show side bar
export const setSideBarVisible = ({commit}: any, visible: boolean) => {
  commit(types.SET_SIDEBAR_VISIBLE, visible);
};
//set login for user
export const setLoggedIn = ({commit}: any, login: boolean) => {
  commit(types.SET_LOGGED_IN, login);
};
//show success toast globally
export const showSuccessToast = ({commit}: any, payload: any) => {
  let msg = payload.msg;
  let title = 'SUCCESS';
  let color = 'success';

  commit(types.SET_TOAST, {msg, title, color});
};
//show error toast globally
export const showErrorToast = ({commit}: any, payload: any) => {
  let msg = payload.msg;
  let title = 'ERROR';
  // let color = 'danger';
  let color = 'error';

  commit(types.SET_TOAST, {msg, title, color});
};

export const setRolesList = async ({commit}: any, payload: any) => {
  commit(types.SET_ROLES, payload);
};

export const setupAppData = async ({commit}: any, payload: any) => {
  let userRoleId = Vue.prototype.$store.getters.userDetails?.type?.roleId;

  // if (userRoleId === 1 || userRoleId === 26) {
  const roles = await getRoleList();
  commit(types.SET_ROLES, roles?.data);
  // }

  commit(types.SET_SHIPS, []);
  const ships = await getShipList();

  commit(types.SET_SHIPS, ships?.data);

  const vopShips = await getShipFromVOP();
  commit(types.SET_SHIPS_FROM_VOP, vopShips?.data);
};

//set logo of company
export const setLogo = ({commit}: any, logo: string) => {
  commit(types.SET_LOGO, logo);
};

export const setShipList = async ({commit}: any, payload: any) => {
  const ships = await getShipList();

  commit(types.SET_SHIPS, ships?.data);
  // commit(types.SET_SHIPS, payload);
};

export const setInspectionData = ({commit}: any, payload: any) => {
  commit(types.SET_INSPECTION_DATA, payload);
};

export const setCurrentTabActionPlan = ({commit}: any, tab: any) => {
  commit(types.SET_CURRENT_TAB_ACTION_PLAN, tab);
};

// export const setShipFromVOP = async ({ commit }: any, payload: any) => {
//   const ships = await getNewShips();

//   commit(types.SET_SHIPS, ships.data);
// //   // commit(types.SET_SHIPS, payload);
// };

export const setInspectionDetailsList = ({commit}: any, payload: any) => {
  commit(types.SET_INSPECTION_LIST_DETAILS, payload);
};

export const setDeckImage = ({commit}: any, payload: any) => {
  commit(types.SET_DECK_IMAGE, payload);
};

export const setUserDetails = async ({commit}: any, payload: any) => {
  commit(types.SET_USER_DETAILS, payload);
  // let userRoleId = Vue.prototype.$store.getters.userDetails?.type?.roleId;
  //
  // if (userRoleId) {
  //   const permissions = await getRoleById(userRoleId);
  //   //
  //   commit(types.SET_USER_DETAILS, {permissions});
  // }
};

export const setUserType = ({commit}: any, payload: any) => {
  commit(types.SET_USER_TYPE, payload);
};
